module.exports = "<h2>{{'general_exams'|translate}}</h2>\n<router-outlet></router-outlet>"